
import { oz } from '@weft/utils';
import { created } from '../../utils/created';
import { CustomerSchema } from '../customer';
import { NewBillingCycleSchema } from './new-billing-cycle-schema';

export const BillingCycleSchema = created(
  NewBillingCycleSchema
    .omit({ customersIds: true })
    .extend({
      customers: oz.array(
        CustomerSchema.pick({ id: true, name: true }),
      ), 
    }),
).openapi('BillingCycle');

export type BillingCycle = oz.infer<typeof BillingCycleSchema>;